import React, { Component } from 'react'
import './JobPlanner.scss'
import Toggle from 'react-toggle'
import update from 'react-addons-update'
import {convertToRaw} from 'draft-js'
import WYSIWYG from '../WYSIWYG'
import { base, colours, debounceTime } from '../../../config'
import * as _ from 'lodash'
import ChartBar from '../ChartBar'
import InvoiceSheet from '../InvoiceSheet'
import GraphView from '../GraphView'
import Actions from '../Actions'
import Overview from '../Overview'
import JobNew from '../JobNew'
import {browserHistory} from 'react-router'
import {debounce} from 'throttle-debounce'
import MediaQuery from 'react-responsive'

class JobPlanner extends Component {

    constructor(props) {
        super(props)
        this.state = {
          active: 0,
          default: {name: 'New Tab',items: []},
          defaultItem: { name: '', cost: 0, sale: 0, quantity: 1, notes: null, showNotes: false },
          job: [{name: 'Expenses', items: []}],
          view: 'tabs-view',
          mainJob: {
            total: {
              cost: 0,
              sale: 0
            }
          }
        }
        this._view = this._view.bind(this)
        this._newTab = this._newTab.bind(this)
        this._newItem = this._newItem.bind(this)
        this._onChange = this._onChange.bind(this)
        this._changeTab = this._changeTab.bind(this)
        this._deleteTab = this._deleteTab.bind(this)
        this._deleteItem = this._deleteItem.bind(this)
        this._onNotesChange = this._onNotesChange.bind(this)
        this._tabName = this._tabName.bind(this)
        //this._changeTotal = this._changeTotal.bind(this)
        this._changeTotal = _.debounce(this._changeTotal, 1000)
        this._notiSave = _.debounce(this._notiSave, 200)


    }

    _notiSave () {
      this.props.notify('Job Saved', 1, 'success')
    }

    componentDidMount () {
      this.setState({view: this.props.view})
      const _this = this
      this.ref = base.syncState(`user_details/${this.props.uid}/plan/${this.props.jobId}`, {
          context: _this,
          state: 'job',
          keepKeys: false,
          then () {
            this.ref = base.syncState(`user_details/${this.props.uid}/jobs/${this.props.jobId}`, {
                context: _this,
                state: 'mainJob',
                keepKeys: false,
                then () {

                }
            })
          }
      })
    }

    _changeTotal () {
      let costArr = []
      let saleArr = []
      this.state.job.map((item, i) => {
        let it = item.items ? item.items : []
        it.map((doc, i) => {
          const quantity = doc.quantity ? doc.quantity : 1
          const cost = doc.cost ? quantity * doc.cost : 0
          const sale = doc.sale ? quantity * doc.sale : 0
          costArr.push(cost)
          saleArr.push(sale)
        })
      })
      const totalCost = costArr.reduce((a, b) => a + b, 0).toFixed(2)
      const totalSale = saleArr.reduce((a, b) => a + b, 0).toFixed(2)
      this.setState({
        mainJob: update(this.state.mainJob, {total: {
          $set: {
            cost: totalCost,
            sale: totalSale
          }
        }})
      })

    }

    _onNotesChange (key, i, target, editorState) {
      const rawDraftContentState = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
      this._onChange(key, i, target, rawDraftContentState)
      this._notiSave()
    }

    _onChange (key, i, target, val, updateTotal) {
      this.setState({
        job: update(this.state.job, {[this.state.active]: {[key]: { [i]: {[target]: {$set: val}}}}})
      })
      this._notiSave()
      if (updateTotal) this._changeTotal()
    }

    _deleteItem (index) {
      let items = this.state.job[this.state.active].items
      items.splice(index, 1)
      this.setState((state) => ({job: update(this.state.job, {[this.state.active]: {'items': { $set: items}}})}))
      this._changeTotal()
    }

    _deleteTab () {
      if (this.state.active === 0) return alert('You have to have at least 1 tab')
      let job = this.state.job
      job.splice(this.state.active, 1)
      const active = this.state.active-1
      this.setState((state) => ({active, job}))
      this._changeTotal()
    }

    _newTab () {
      const active = this.state.active+1
      let job = this.state.job
      job.push(this.state.default)
      this.setState((state) => ({job, active}))
    }

    _newItem () {
      let items = _.get(this.state.job[this.state.active], 'items', [])
      items.push(this.state.defaultItem)
      this.setState((state) => ({job: update(this.state.job, {[this.state.active]: {'items': { $set: items}}})}))
    }

    _changeTab (active) {
      this.setState((state) => ({active}))
    }

    _view (index) {
      $(window).scrollTop(0)
      this.setState({view: index})
    }

    _view (index) {
      $(window).scrollTop(0)
      this.setState({view: index})
    }

    _edit () {
      this.setState({
        edit: !this.state.edit
      })
    }

    _delete () {
      this.setState({
        delete: !this.state.delete
      })
    }

    _fullDelete () {
      const _this = this
      browserHistory.push('/jobs')
      base.remove(`user_details/${this.props.uid}/jobs/${this.props.jobId}`)
      base.remove(`user_details/${this.props.uid}/plan/${this.props.jobId}`)
      _this.props.notify('Job Sucessfully Deleted', 1, 'success')
    }


    _duplicate (value) {
      const _this = this
      let newJob2 = this.state.mainJob
      newJob2.label = `${this.state.mainJob.label} Copy`
      const immediatelyAvailableReference = base.push(`user_details/${this.props.uid}/jobs`, {
        data: newJob2
      })
      const generatedKey = immediatelyAvailableReference.key
      base.fetch(`user_details/${this.props.uid}/plan/${this.props.jobId}`, {
        context: this,
        then(data){
          base.post(`user_details/${this.props.uid}/plan/${generatedKey}`, {
            data: data,
            then () {
              browserHistory.push(`/job/${generatedKey}/tabs-view`)
              _this.props.notify('Job Sucessfully Duplicated', 1, 'success')
            }
          })
        }
      })
    }

    _tabName (val) {
      this.setState((state) => ({job: update(this.state.job, {[this.state.active]: {'name': { $set: val}}})}))
    }

    render() {

        let tabs = this.state.job.map((item, index) => {
          return (
            <li key={index} className={this.state.active === index ? 'active' : ''}>
              <a style={{background: this.props.colors[index]}} onClick={this._changeTab.bind(this, index)}>{item.name}</a>
              <span className='glyphicon glyphicon-remove remove' />
            </li>
          )
        })

        const items = _.get(this.state.job[this.state.active], 'items', []).map((item, i) => {
          return (
            <div key={`row${i}`} className="item">
              <div className='row'>
                <div className='form-group col-md-3 col-lg-5'>
                  <label>Name</label> <input className="form-control" placeholder="Name" type="text" value={item.name} onChange={(e) => this._onChange('items', i, 'name', e.target.value)} />
                </div>
                <div className='form-group col-xs-6 col-sm-2'>
                  <label>Cost</label> <input className="form-control" placeholder="Cost" type="number" value={item.cost} onChange={(e) => this._onChange('items', i, 'cost', e.target.value, true)} />
                </div>
                <div className='form-group col-xs-6 col-sm-2'>
                  <label>Sale</label> <input className="form-control" placeholder="Sale" type="number" value={item.sale} onChange={(e) => this._onChange('items', i, 'sale', e.target.value, true)} />
                </div>
                <div className='form-group col-xs-5 col-sm-1'>
                  <label>Quantity</label> <input className="form-control" placeholder="Quantity" type="number" value={item.quantity} onChange={(e) => this._onChange('items', i, 'quantity', e.target.value, true)} />
                </div>
                <div className='form-group col-xs-3 col-sm-1'>
                  <label>Notes</label> <br/><Toggle checked={item.showNotes} onChange={(e) => this._onChange('items', i, 'showNotes', !item.showNotes)} />
                </div>
                <div className='col-xs-4 col-sm-1'>
                  <label>&nbsp;</label> <button className="btn btn-danger btn-block" onClick={(e) => this._deleteItem(i)}><i className="glyphicon glyphicon-remove" /></button>
                </div>
                <div className='clear'>
                  <div className="col-sm-12">
                    {item.showNotes && <WYSIWYG key={`editor{i}`} action={(e) => this._onNotesChange('items', i, 'notes', e)} content={item.notes ? item.notes : null} />}
                  </div>
                </div>
              </div>
            </div>
          )
        })

        const valArr = []

        const ChartBarData = _.get(this.state.job[this.state.active], 'items', []).map((item, i) => {
          const quantity = item.quantity ? item.quantity : 1
          const cost = item.cost ? quantity * item.cost : 0
          const sale = item.sale ? quantity * item.sale : 0
          valArr.push(cost, sale)
          return {
            "tabs": item.name,
            "Cost": cost,
            "Sale": sale,
            "Profit": sale - cost
          }
        })



        const cost = ChartBarData.map(item => (item.Cost)).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)
        const sale = ChartBarData.map(item => (item.Sale)).reduce((a, b) => Number(a) + Number(b), 0).toFixed(2)

        let max = Math.max(...valArr)

        const tabName = this.state.job[this.state.active] && this.state.job[this.state.active].name ? this.state.job[this.state.active].name : ''

        return (
            <div className='job-planner'>


            <div className='row'>
              <div className='col-sm-3'>
                <Actions
                  colors={colours}
                  active={this.state.tab}
                  tabName={tabName}
                  mainJob={this.state.mainJob}
                  job={this.state.job}
                  jobId={this.props.jobId}
                  uid={this.props.uid}
                  _view={this._view}
                  view={this.props.view}
                  _tabName={this._tabName}
                  _deleteTab={this._deleteTab}
                />
              </div>

              {this.props.view === 'tabs-view' &&
                <div className='col-sm-9'>

                  <div className='tabs'>
                    <ul>
                      {tabs}
                      <li onClick={this._newTab}>
                        <a style={{background: 'purple'}}><span className='glyphicon glyphicon-plus add' /></a>
                      </li>
                    </ul>
                  </div>

                  <div className="items">
                    {items}
                    <div className='row'>
                      <div className='col-sm-4 pull-right'>
                        <button onClick={this._newItem} className="btn btn-info btn-block"><i className="glyphicon glyphicon-plus" /></button>
                      </div>
                    </div>
                    <div className='charter'>
                      <ChartBar height={300} maxValue={max + (max / 10)} data={ChartBarData} keys={["Cost","Sale", "Profit"]} />

                      <Overview
                        profit={sale - cost}
                        cost={cost}
                        sale={sale}
                      />

                    </div>
                  </div>

                  <div className="visible-xs">
                    <Actions
                      colors={colours}
                      active={this.state.tab}
                      tabName={tabName}
                      mainJob={this.state.mainJob}
                      job={this.state.job}
                      jobId={this.props.jobId}
                      uid={this.props.uid}
                      _view={this._view}
                      view={this.props.view}
                      _tabName={this._tabName}
                      _deleteTab={this._deleteTab}
                      mobile
                    />
                  </div>

                </div>
              }
              {this.props.view === 'quote-view' && this.state.job && this.state.mainJob &&
                <div className="col-sm-9">
                  <InvoiceSheet
                    title='QUOTE'
                    type='quote'
                    class='bg-info'
                    btnClass='bg-danger'
                    uid={this.props.uid}
                    job={this.state.job}
                    details={this.props.details}
                    mainJob={this.state.mainJob}
                    headerColor='#68a6d7'
                    jobId={this.props.jobId}
                    notify={this.props.notify}
                  />
                </div>
              }
              {this.props.view === 'invoice-view' && this.state.job && this.state.mainJob &&
                <div className="col-sm-9">
                  <InvoiceSheet
                    title='INVOICE'
                    type='invoice'
                    class='bg-danger'
                    btnClass='bg-danger'
                    uid={this.props.uid}
                    job={this.state.job}
                    details={this.props.details}
                    mainJob={this.state.mainJob}
                    headerColor='#d4382f'
                    jobId={this.props.jobId}
                    notify={this.props.notify}
                  />
                </div>
              }
              {this.props.view === 'receipt-view' && this.state.job && this.state.mainJob &&
                <div className="col-sm-9">
                  <InvoiceSheet
                    title='RECEIPT'
                    type='receipt'
                    class='bg-success'
                    btnClass='bg-warning'
                    uid={this.props.uid}
                    job={this.state.job}
                    details={this.props.details}
                    mainJob={this.state.mainJob}
                    headerColor='#90c33c'
                    jobId={this.props.jobId}
                    notify={this.props.notify}
                  />
                </div>
              }

              {this.props.view === 'graph-view' &&
                <div className="col-sm-9">
                  <GraphView
                    title='Quote'
                    job={this.state.job}
                  />
                </div>
              }
              {this.props.view === 'edit-view' &&
                <div className="col-sm-9">
                  <div className='row'>
                    <div className='col-lg-8 hide-submit'>
                      <JobNew
                        edit={true}
                        jobId={this.props.jobId}
                        job={this.state.mainJob}
                        finsihed={this._edit.bind(this)}
                        uid={this.props.uid}
                        newJob={this._edit.bind(this)}
                        formClass="col-sm-12"
                        notify={this.props.notify}
                        />
                    </div>
                    <div className='col-lg-4'>
                      <div className='panel panel-info'>
                        <div className='panel-heading'>
                          Job Actions
                        </div>
                        <div className='panel-body'>
                          <button onClick={this._duplicate.bind(this)} type="button" className='btn btn-block btn-warning m-b-lg'>Duplicate Job <i className="icon-copy"></i></button>
                          <button onClick={this._delete.bind(this)} type="button" className='btn btn-block btn-danger'>Delete Job <i className="icon-delete"></i></button>
                          {this.state.delete &&
                            <div className='m-t-md'>
                              <label htmlFor="">Do you really want to delete this job?</label><br/>
                              <div className='row'>
                                <div className='col-sm-6'>
                                  <button onClick={this._delete.bind(this)} type="button" className='btn btn- btn-block btn-info'>NO</button>
                                </div>
                                <div className='col-sm-6'>
                                <button onClick={this._fullDelete.bind(this)} type="button" className='btn btn- btn-block btn-danger'>YES</button>
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }












</div>
            </div>
        )
    }
}


// /<MediaQuery maxWidth={991}>

export default JobPlanner



// WEBPACK FOOTER //
// ./src/views/components/JobPlanner/index.js